import { render, staticRenderFns } from "./appSideRight.vue?vue&type=template&id=195545bb&scoped=true&"
import script from "./appSideRight.vue?vue&type=script&lang=js&"
export * from "./appSideRight.vue?vue&type=script&lang=js&"
import style0 from "./appSideRight.vue?vue&type=style&index=0&id=195545bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195545bb",
  null
  
)

export default component.exports